import api from './index';

let exports = {};

// 我收到的投诉
exports.getRecvComplaintList = function (params, callback) {// 我的收到的投诉分页列表
    api.post('/custsvc/recv/complaint/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 我发起的投诉
exports.getSentComplaintList = function (params, callback) {// 我发起的投诉分页列表
    api.post('/custsvc/sent/complaint/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 获取投诉类型
exports.getComplaintTypeList = function (params, callback) {// 获取投诉类型列表
    api.post('/custsvc/complaint/type/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 发起投诉
exports.saveComplaint = function (params, callback) {// 发起投诉
    api.post('/custsvc/complaint/save/do')
    .data(params)
    .done(callback)
    .go();
};

// 投诉处理
exports.handleComplaint = function (params, callback) {// 投诉处理
    api.post('/custsvc/complaint/handle/do')
    .data(params)
    .done(callback)
    .go();
};

// 请求记录
exports.getComplaintReqRecList = function (params, callback) {// 获取投诉请求记录列表
    api.post('/custsvc/complaint/req/rec/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 获取投诉信息
exports.getComplaintInfo = function (params, callback) {// 获取投诉详情
    api.post('/custsvc/complaint/info/get')
    .data(params)
    .done(callback)
    .go();
};

// 响应记录
exports.getComplaintRspRecList = function (params, callback) {// 获取投诉响应记录列表
    api.post('/custsvc/complaint/rsp/rec/list/get')
    .data(params)
    .done(callback)
    .go();
};

// 投诉订单的信息
exports.getComplaintOrderInfo = function (params, callback) {// 投诉的订单信息
    api.post('/custsvc/complaint/order/info/get')
    .data(params)
    .done(callback)
    .go();
};

// 结束投诉
exports.finishConfirmComplaint = function (params, callback) {// 投诉完成确认
    api.post('/custsvc/complaint/finish/confirm/do')
    .data(params)
    .done(callback)
    .go();
};

export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/custsvc.js
// module id = 133
// module chunks = 1